<template>
  <el-dialog :visible.sync="dialogVisible" center width="650px" label-width="80px" height="360px" @closed="cancleDialog"
    custom-class="register-dialog" :close-on-click-modal="false" title="" append-to-body>

    <div class="login-container">
      <div class="left-add">
        <img src="../../assets/login.jpg" alt="" width="200px">
      </div>
      <div class="form-login">
        <div class="register-form">
          <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="0" class="register-form">

            <el-tabs v-model="activeType" :stretch="true">
              <el-tab-pane label="密码登录" name="first">
                <div v-if="activeType == 'first'">
                  <el-form-item label="" prop="username">
                    <el-input v-model="registerForm.username" placeholder="请输入手机号">
                      <!-- <template slot="prepend">手机号</template> -->
                    </el-input>
                  </el-form-item>

                  <el-form-item label="" prop="password">
                    <el-input v-model="registerForm.password" type="password" placeholder="输入不少于8位数大小写字母和数字的密码"
                      show-password>
                      <!-- <template slot="prepend">密　码</template> -->
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item label="手机号" prop="mobile">
          <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
         -->

                  <!-- <el-form-item label="验证码" prop="code">
                    <div class="code-container">
                      <el-input v-model="registerForm.code" placeholder="请输入图形验证码" style="width: 60%"></el-input>
                      <div class="code-img" @click="refreshCaptcha">
                        <img :src="captchaImage" alt="图形验证码">
                      </div>
                    </div>
                  </el-form-item> -->
                </div>

              </el-tab-pane>
              <el-tab-pane label="验证码登录" name="second">
                <div v-if="activeType == 'second'">
                  <el-form-item label="" prop="mobile">
                    <el-input v-model="registerForm.mobile" placeholder="请输入手机号">
                      <!-- <template slot="prepend">手机号</template> -->
                    </el-input>
                  </el-form-item>

                  <el-form-item label="" prop="smsCode">
                    <div class="sms-container">
                      <el-input v-model="registerForm.smsCode" placeholder="请输入验证码">
                        <!-- <template slot="prepend">验证码</template> -->

                        <el-button :disabled="!canGetSmsCode || countdown > 0" @click="getSmsCode" slot="append">
                          {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                        </el-button>
                      </el-input>
                    </div>
                  </el-form-item>
                </div>

              </el-tab-pane>

            </el-tabs>





            <!-- 用户协议 -->
            <div class="agreement-text">
              <el-checkbox v-model="agreed">我已阅读并同意遵守</el-checkbox>
              <span class="agreement-link" @click="showAgreement">《用户协议》</span>和
              <span class="agreement-link" @click="showPrivacy">《隐私政策》</span>
            </div>



            <el-button :disabled="!agreed" class="login-button" type="primary" @click="submitForm('registerForm')"> 登录 /
              注册 </el-button>
            <!-- <el-button @click="resetForm('registerForm')">重置</el-button> -->

            <!-- 底部说明文字 -->
            <div class="footer-text">
              未注册手机，验证后将自动创建账号登录
            </div>
          </el-form>
        </div>
      </div>
    </div>




  </el-dialog>

</template>
<script>
import {
  login,
  captchaImage,
  userProfile,
  sendSmsCode,
  smsLogin
} from "@/api/index";
import {
  setToken
} from "@/utils/auth";
import {
  mapMutations,
  mapActions
} from "vuex";
export default {
  props: {
    loginDialogVisible: {
      default: false,
    },

  },
  data() {
    // 密码复杂度验证
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      // 密码必须包含大小写字母和数字
      const hasUpperCase = /[A-Z]/.test(value);
      const hasLowerCase = /[a-z]/.test(value);
      const hasNumber = /[0-9]/.test(value);

      if (!hasUpperCase || !hasLowerCase || !hasNumber) {
        return callback(new Error('输入不少于8位数大小写字母和数字的密码'));
      }

      if (value.length < 8) {
        return callback(new Error('密码长度不能少于8位'));
      }

      callback();
    };

    // 手机号验证规则
    const validatemobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      const reg = /^1[3-9]\d{9}$/;
      if (!reg.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      }
      callback();
    };

    // 图形验证码验证规则
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入图形验证码'));
      }
      // if (value.length !== 4) {
      //   return callback(new Error('验证码长度为4位'));
      // }
      callback();
    };

    return {
      callback: null,
      resolve: null,
      reject: null,
      agreed: false, // 是否同意协议
      activeType: 'first',
      dialogVisible: this.loginDialogVisible,
      registerForm: {
        username: '',
        password: '',
        mobile: '',
        code: '',
        smsCode: '',
        uuid: ''
      },
      rules: {
        username: [
          { validator: validatemobile, trigger: 'blur' }
          // { required: true, message: '请输入手机号', trigger: 'blur' },
          // { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        mobile: [
          { validator: validatemobile, trigger: 'blur' }
        ],
        code: [
          { validator: validateCaptcha, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { len: 4, message: '验证码长度为4位', trigger: 'blur' }
        ]
      },
      captchaImage: '', // 图形验证码图片
      captchaToken: '', // 图形验证码token
      countdown: 0,     // 短信验证码倒计时
      canGetSmsCode: false, // 是否可以获取短信验证码
      config: {},
    };
  },
  mounted() {


  },
  watch: {
    loginDialogVisible: function (dialogVisible) {
      this.dialogVisible = dialogVisible;
      // if (dialogVisible) this.refreshCaptcha();
    },
    'registerForm.mobile'(newVal) {
      const reg = /^1[3-9]\d{9}$/;
      this.canGetSmsCode = reg.test(newVal);
    },
  },
  methods: {
    ...mapMutations([
      'set_user_token'
    ]),
    ...mapActions(["getUserInfo"]),

    open(config = {},callback) {
      this.config = config
      this.dialogVisible = true
      this.callback = callback
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    // 显示用户协议
    showAgreement() {
      // this.$router.push('/agreement');
      window.open('/agreement', '_blank');

    },

    // 显示隐私政策
    showPrivacy() {
      // this.$router.push('/privacy');
      window.open('/privacy', '_blank');

      // this.$alert('这里是隐私政策内容', '隐私政策', {
      //   confirmButtonText: '确定'
      // });
    },
    // 刷新图形验证码
    refreshCaptcha() {

      // 这里应该是调用API获取验证码图片
      // 模拟生成一个随机验证码
      // const randomStr = Math.random().toString(36).substr(2, 4).toUpperCase();
      // this.captchaToken = randomStr;

      // 实际项目中这里应该是从后端获取验证码图片
      // 这里用canvas模拟生成一个验证码图片
      // this.generateCaptchaImage(randomStr);


      // captchaImage().then(response => {
      //   this.captchaImage = 'data:image/png;base64,' + response.img;
      //   this.registerForm.uuid = response.uuid
      // }).catch(error => {
      //   this.$message.error(error.message);

      // });

    },

    // 获取短信验证码
    getSmsCode() {

      // 验证手机号和图形验证码
      this.$refs.registerForm.validateField(['mobile'], (errors) => {


        if (!errors) {


          // 开始倒计时
          this.countdown = 60;
          const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);

          // 调用API发送短信验证码
          // this.$message.success('验证码已发送');
          console.log('发送短信验证码到:', this.registerForm.username);
          // 这里应该是调用API发送短信验证码
          sendSmsCode({
            username: this.registerForm.mobile,
            password: ' ',
            code: ' ',
            uuid: ' ',
            mobile: ' ',
            smsCode: '',
          }).then(response => {
            this.registerForm.uuid = response.uuid
            this.$message.success('验证码已发送');

          }).catch(error => {

            this.$message.error(error.message);
            // this.refreshCaptcha();
          });
        } else {
          console.log(errors)
        }
      });
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid, mes) => {
        if (valid) {
          // 提交注册
          // console.log('信息:', this.registerForm,this.$route);
          this.set_user_token({
            token: ""
          });

          // 密码登录
          if (this.activeType == 'first') {
            login(
              {
                username: this.registerForm.username,
                mobile: this.registerForm.username,
                password: this.registerForm.password,
                inviteCode: this.$route?.query?.inviteCode
                // code: this.registerForm.code,
                // uuid: this.registerForm.uuid
              }
            ).then(async response => {
              
              if (response.code === 200) {
                setToken(response.token);
                this.set_user_token({
                  token: response.token
                });
                this.cancleDialog();
                this.$message.success('登录成功');
                

                const userResult = await this.getUserInfo();
               this.resolve(userResult)

                // //如果用户没有填写行业 职业 单位 则提示用户填写，点击确定跳转账户中心
                // if (userResult && userResult.data && (!userResult.data.profession || !userResult.data.censusRegister || !userResult.data.archivesLocation)) {
                //   this.$router.push('/setting');

                //   // this.$alert('建议完善相关信息，以便提供精准回答', '温馨提示', {
                //   //   confirmButtonText: '确定',
                //   //   showClose:false,
                //   //   callback: action => {
                //   //     this.$router.push('/setting');
                //   //   }
                //   // });

                // }
 
              } else {
                this.$message.error(response.msg);
                this.refreshCaptcha();
              }

            }).catch(error => {
              console.log(3);
              this.$message.error(error.message);
              this.refreshCaptcha();
            });
          } else {

            // 手机验证码登录
            smsLogin(
              {
                username: this.registerForm.mobile,
                // password: '',
                // code: '',
                uuid: this.registerForm.uuid,
                mobile: this.registerForm.mobile,
                smsCode: this.registerForm.smsCode,
                inviteCode: this.$route?.query?.inviteCode
              }
            ).then(async response => {
              if (response.code === 200) {

                setToken(response.token);
                this.set_user_token({
                  token: response.token
                });
                this.cancleDialog();



                const userResult = await this.getUserInfo();

                if (response.firstLogin) {
                  this.$message.success('登录成功,初始密码：Aa123456');
                } else {
                  this.$message.success('登录成功');
                }
               this.resolve(userResult)

                // if (userResult && userResult.data && (!userResult.data.profession || !userResult.data.censusRegister || !userResult.data.archivesLocation)) {
                //   this.$router.push('/setting');
                // }


              } else {
                this.$message.error(response.msg);
              }

            }).catch(error => {
   
              this.$message.error(error.message);
            });
          }



        } else {
          console.log('表单验证失败', valid, mes);
          return false;
        }
      });
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.refreshCaptcha();
      this.countdown = 0;
    },
    changeDialog() {
      // this.$emit("scDialog", { showdialog: false, showLog: true });
      this.dialogVisible = false;
    },

    cancleDialog() {
      this.$refs["registerForm"].resetFields();
      // this.$emit("scDialog", { showdialog: false });
      this.dialogVisible = false;
    },


  },
};
</script>
<style lang="scss" scoped>
.agreement-text {
  font-size: 14px;
  color: #606266;
  margin-top: 10px;
}

.agreement-link {
  color: #409EFF;
  cursor: pointer;
}

.footer-text {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 15px;
}

.login-button {
  width: 100%;
  margin-top: 20px;
  height: 40px;
  font-size: 16px;
}

.login-container {
  display: flex;

  .left-add {
    flex: 0 0 auto;
    width: 352px;
    background: #3f8de2;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.code-container,
.sms-container {
  // display: flex;
  // align-items: center;
}

.code-img {
  margin-left: 10px;
  cursor: pointer;
}

.code-img img {
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

::v-deep .register-dialog {
  border-radius: 20px;
  max-width: 750px;
  width: 90% !important; // 移动端自适应
  overflow: hidden;

  .el-dialog__header {
    // display: none;
    position: absolute;
    right: 0
  }

  .el-dialog__body {
    padding: 0px 20px 0 0;
  }

  .form-login {
    padding: 20px;
  }

  .register-form {
    .el-form-item {
      margin-bottom: 22px;
    }

    .password-tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }

    .captcha-container,
    .sms-container {
      // display: flex;
      // align-items: center;

      // .el-input {
      //   flex: 1;
      //   margin-right: 10px;
      // }
    }

    .captcha-img {
      width: 100px;
      height: 40px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }
    }

    .sms-btn {
      width: 120px;
      white-space: nowrap;
    }
  }

  .el-tabs__header {
    margin-bottom: 50px;
  }
}

@media (max-width: 992px) {
  ::v-deep .register-dialog {
    width: 500px !important;
  }

  .login-container {
    justify-content: center;
  }

  .left-add {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  ::v-deep .register-dialog {
    width: 95% !important;

    .el-form-item__label {
      width: 80px !important;
    }

    .el-form-item__content {
      // margin-left: 80px !important;
    }

    .captcha-container,
    .sms-container {
      // flex-direction: column;
      // align-items: flex-start;

      .el-input {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
      }
    }

    .sms-btn {
      width: 100%;
    }
  }
}
</style>
